import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';
import { GeneralSmartParkError } from 'src/registry/types/axios';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/visitors/access-key/:id/`;
type MutationFnType = typeof mutationFn;

interface DTO {
    id: string;
    parkingId: string;
}
const mutationFn = ({ id, parkingId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { id, parkingId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteAccessKey };
